import common from "../../utill/Common";

class MessagingService {
  sendToAllTopic = async (token, title, body, image) => {
    const url = common.baseUrl + "admin/messaging/push/send_to_all_topic";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        title,
        body,
        image,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  sendToAllTokens = async (token, title, body, image) => {
    const url = common.baseUrl + "admin/messaging/push/send_to_all_tokens";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        title,
        body,
        image,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  sendToUser = async (token, userId, title, body, image) => {
    const url = common.baseUrl + "admin/messaging/push/send_to_user";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        userId,
        title,
        body,
        image,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  imgToLink = async (token, file) => {
    const url = common.baseUrl + "admin/messaging/push/img_to_link";

    const formData = new FormData();
    formData.append("image", file);

    const options = {
      method: "POST",
      headers: {
        "x-access-token": token,
        // ⚠️ do NOT set Content-Type — the browser sets it with the boundary
      },
      body: formData,
    };

    const response = await fetch(url, options);
    return response.json();
  };

  getPushHistory = async (token, limit = 30) => {
    const url = common.baseUrl + `admin/messaging/push/history?limit=${limit}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    return response.json();
  };

  removePushHistory = async (token, id) => {
    const url = common.baseUrl + `admin/messaging/push/history/delete/${id}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    return response.json();
  };

  clearPushHistory = async (token) => {
    const url = common.baseUrl + "admin/messaging/push/history/clear";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    return response.json();
  };

  /* ---------------- in-app messages ---------------- */

  createInAppMessage = async (token, payload) => {
    const url = common.baseUrl + "admin/messaging/in_app_message";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(url, options);
    return response.json();
  };

  updateInAppMessage = async (token, id, payload) => {
    const url = common.baseUrl + `admin/messaging/in_app_message/update/${id}`;

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(url, options);
    return response.json();
  };

  deleteInAppMessage = async (token, id) => {
    const url = common.baseUrl + `admin/messaging/in_app_message/delete/${id}`;

    const options = {
      method: "POST",
      headers: {
        "x-access-token": token,
      },
    };

    const response = await fetch(url, options);
    return response.json();
  };

  getInAppMessages = async (token) => {
    const url = common.baseUrl + "admin/messaging/in_app_message";

    const options = {
      method: "GET",
      headers: {
        "x-access-token": token,
      },
    };

    const response = await fetch(url, options);
    return response.json();
  };

  notifyInAppMessage = async (token) => {
    const url = common.baseUrl + "admin/messaging/in_app_message/notify";

    const options = {
      method: "POST",
      headers: {
        "x-access-token": token,
      },
    };

    const response = await fetch(url, options);
    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new MessagingService();
